export const useDraftSaveConfig = ({
  draftSaveFailed
}) => {
  const draftSaveCapability = draftSaveFailed ? {
    DRAFT_NOT_SAVED: {}
  } : {};
  return Object.assign({}, draftSaveCapability);
};